const SENSITIVE_FIELDS = [
    "authorization",
    "proxy-authorization",
    "token",
    "accessToken",
    "access_token",
    "refreshToken",
    "refresh_token",
    "idToken",
    "id_token",
    "jwt",
    "password",
    "passwd",
    "secret",
    "clientSecret",
    "client_secret",
    "apiKey",
    "api_key",
    "privateKey",
    "private_key",
    "cookie",
    "set-cookie",
    "session",
    "credentials",
];

const REDACTED_VALUE = "[REDACTED]";

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
    if (value === null || typeof value !== "object") {
        return false;
    }

    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
};

const isSensitiveField = (fieldName: string): boolean => {
    return SENSITIVE_FIELDS.some(
        (sensitiveField) => sensitiveField.toLowerCase() === fieldName.toLowerCase()
    );
};

const sanitizeString = (value: string): string => {
    let sanitized = value.replace(
        /\beyJ[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+\b/g,
        REDACTED_VALUE
    );

    sanitized = sanitized.replace(
        /\bBearer\s+[a-zA-Z0-9._~+/=-]+/gi,
        `Bearer ${REDACTED_VALUE}`
    );

    return sanitized;
};

const sanitizeValue = (data: unknown, seen: WeakSet<object>): unknown => {
    if (typeof data === "string") {
        return sanitizeString(data);
    }

    if (Array.isArray(data)) {
        if (seen.has(data)) {
            return "[Circular]";
        }

        seen.add(data);
        return data.map((item) => sanitizeValue(item, seen));
    }

    if (isPlainObject(data)) {
        if (seen.has(data)) {
            return "[Circular]";
        }

        seen.add(data);

        const sanitized: Record<string, unknown> = {};

        Object.entries(data).forEach(([key, value]) => {
            sanitized[key] = isSensitiveField(key)
                ? REDACTED_VALUE
                : sanitizeValue(value, seen);
        });

        return sanitized;
    }

    return data;
};

const sanitize = <T>(data: T): T => {
    return sanitizeValue(data, new WeakSet<object>()) as T;
};

export const SensitiveDataSanitizer = {
    sanitize,
    isSensitiveField,
    REDACTED_VALUE,
};